import { render, staticRenderFns } from "./DirectReceiveDenyPopup.vue?vue&type=template&id=5634b571"
import script from "./DirectReceiveDenyPopup.vue?vue&type=script&lang=js"
export * from "./DirectReceiveDenyPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports